/**
 * @file SearchInput 搜索输入
 * @description 带搜索图标与清除按钮的 Input 封装。
 *
 * @whenToUse 列表筛选、工具栏搜索。
 * @whenNotToUse 普通表单字段（用 Input）。
 */

import { Search, X } from 'lucide-react'
import { Input, type InputProps } from '@/components/ui/input.tsx'

export type SearchInputProps = Omit<InputProps, 'prefix' | 'suffix' | 'type'> & {
  /** 点击清除（通常清空 value） */
  onClear?: () => void
}

export function SearchInput({
  value,
  onClear,
  ...rest
}: SearchInputProps) {
  const hasValue = value !== undefined && String(value).length > 0

  return (
    <Input
      type="search"
      value={value}
      prefix={<Search aria-hidden />}
      suffix={
        hasValue && onClear ? (
          <button
            type="button"
            aria-label="清除"
            className="inline-flex text-muted transition-opacity duration-200 hover:opacity-90"
            onClick={onClear}
          >
            <X aria-hidden />
          </button>
        ) : undefined
      }
      {...rest}
    />
  )
}
